import GameBoard, { GameBoardPlayer } from '@/src/components/GameBoard';

const players: GameBoardPlayer[] = [
  { id: 'sasha', name: 'Sasha', src: '/business-avatars/sasha.jpeg', tile: 7 },
  { id: 'james', name: 'James', src: '/business-avatars/james.jpeg', tile: 11 },
  { id: 'mei', name: 'Mei', src: '/business-avatars/mei.jpeg', tile: 6 },
  { id: 'mark', name: 'Mark', src: '/business-avatars/mark.jpeg', tile: 4 },
  { id: 'elena', name: 'Elena', src: '/business-avatars/elena.jpeg', tile: 3 },
  { id: 'diego', name: 'Diego', src: '/business-avatars/diego.jpeg', tile: 2 },
  { id: 'noor', name: 'Noor', src: '/business-avatars/noor.jpeg', tile: 1 },
];

export default function BusinessGameBoard() {
  return (
    <GameBoard
      youId="sasha"
      players={players}
      headerName="Sasha M."
      annotation="live game"
    />
  );
}
